import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SecretService } from '../../services/secret.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-secret-menu',
  imports: [CheckboxModule, FormsModule, InputTextModule, ButtonModule],
  providers: [],
  templateUrl: './secret-menu.component.html',
  styleUrl: './secret-menu.component.scss',
})
export class SecretMenuComponent implements OnInit {
  private secretService = inject(SecretService);
  private sessionService = inject(SessionService);

  public betterError: boolean | undefined;
  public username!: string;
  public env = environment.env;
  public isSysadmin = signal(this.sessionService.checkUserPermissionsAny(['SYSADMIN']));

  async ngOnInit() {
    this.betterError = await firstValueFrom(this.secretService.betterErrors$);
  }

  betterErrorChange(betterError: boolean) {
    this.secretService.betterErrors = betterError;
  }

  async changeUser() {
    await this.sessionService.changeUser(this.username);
    this.isSysadmin.set(this.sessionService.checkUserPermissionsAny(['SYSADMIN']));
  }
}
